import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItems} from "../../common/models/menu-items.model";
import {MatDialog} from "@angular/material/dialog";
import {AccessibilityComponent} from "../accessibility/accessibility.component";
import {Interlignage, PoliceNames, style} from "../../common/models/style.model";
import {ThemeChoiceComponent} from "../theme-choice/theme-choice.component";


@Component({
  selector: 'app-activities-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @Input() menuItems: MenuItems = <MenuItems>{};
  @Input() mainStyle: style = <style>{};
  @Input() interlignage: Interlignage = Interlignage.default;
  @Input() police: PoliceNames = PoliceNames.default;
  @Output() myActivities = new EventEmitter<Boolean>();
  @Output() displayFilters = new EventEmitter<Boolean>();
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  goActivitiesList(): void{
    this.myActivities.emit(false);
  }

  goMyActivities(): void{
    this.myActivities.emit(true);
  }

  getFilters(): void {
    this.displayFilters.emit(true);
  }

  setAccessibility(): void {
    const data = {mainStyle: this.mainStyle, interlignage: this.interlignage, police: this.police};
    const dialogRef = this.dialog.open(AccessibilityComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});

  }

  setTheme(): void {
    const data = {mainStyle: this.mainStyle, interlignage: this.interlignage, police: this.police};
    const dialogRef = this.dialog.open(ThemeChoiceComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});
  }
}
